<template>
  <div class="w-ful">
    <SmartRow>
      <SmartFilter
        :visit="visits"
      />
    </SmartRow>

    <div class="header-action my-4 flex justify-between">
      <SmartTitle>
        Visitas agendadas para hoje
      </SmartTitle>
    </div>

    <v-data-table
      :items="visits"
      :headers="headers"
      hide-actions
      :pagination.sync="pagination"
    >
      <template v-slot:items="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.place }}</td>
          <td>{{ item.hour }}</td>
          <td>
            <SmartTag
              :label="item.status"
            />
          </td>
          <td>
            <SmartIcon
              type="small"
              :size="3"
              name="tasks"
              style="cursor: pointer"
              @click="showInfo(item.id)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-pagination
        v-model="current_page"
        @input="callPagination"
        :length="length"
        :total-visible="10"
        :value="0"
        class="flex mt-2 justify-center"
        circle
      />
    </div>

    <div class="mb-4 mt-3">
      <SmartTitle>
        Visitas agendadas para amanhã
      </SmartTitle>
    </div>

    <v-data-table
      :items="visitsNext"
      :headers="headersNext"
      hide-actions
      :pagination.sync="paginationNext"
      loading
    >
      <template v-slot:items="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.place }}</td>
          <td>{{ item.hour }}</td>
          <td>
            <SmartTag
              :label="item.status"
            />
          </td>
          <td>
            <SmartIcon
              type="small"
              :size="3"
              name="tasks"
              style="cursor: pointer"
              @click="showInfo(item.id)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-pagination
        v-model="getPagination.current_page"
        :length="getPagination.last_page" :value="0"
        class="flex justify-center mt-2 mb-2"
        circle
      />
    </div>
    <div>
      <SmartDrawer
        @close="() => {
          showDrawer = false;
          visitNext = null;
        }"
        :show="showDrawer">
        <template v-slot:header>
          <SmartTitle>Informações da visita</SmartTitle>
        </template>
        <InfoVisit v-if="visit" :visit="visit"/>
      </SmartDrawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { formatUSDate } from 'utils';

export default {
  name: 'PlaceVisits',
  components: {
    SmartTitle: () => import('packages/SmartTitle'),
    SmartIcon: () => import('packages/SmartIcon'),
    SmartTag: () => import('packages/SmartTag'),
    SmartDrawer: () => import('packages/SmartDrawer'),
    InfoVisit: () => import('./InfoVisit'),
    SmartFilter: () => import('./SmartFilter')
  },
  data() {
    return {
      loading: null,
      current_page: null,
      visit: null,
      showDrawer: false,

      pagination: {
        rowsPerPage: 10
      },

      paginationNext: {
        rowsPerPage: 10
      },

      headers: [
        { text: 'Executivo', value: 'user.name' },
        { text: 'Ponto de venda', value: 'place.name' },
        { text: 'Horário marcado', value: 'visit_date' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions' }
      ],

      headersNext: [
        { text: 'Executivo', value: 'user.name' },
        { text: 'Ponto de venda', value: 'place.name' },
        { text: 'Horário marcado', value: 'visit_date' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions' }
      ]
    };
  },
  methods: {
    ...mapActions(
      {
        fetchVisits: 'visit/fetchVisits',
        fetchVisitsByPage: 'visit/fetchVisitsByPage'
      }
    ),

    ...mapActions('visitNextDay', ['fetchVisitsNext']),
    visitNextDay() {
      this.$router.push({ name: 'Visitas' });
    },

    showInfo(id) {
      this.visit = this.getVisitId(id) || {};
      this.showDrawer = true;
    },

    showInfoNext(id) {
      this.visitNext = this.getVisitIdNext(id);
      this.showDrawer = true;
    },

    async callPagination(indexPage) {
      this.loading = true;
      await this.fetchVisitsByPage(indexPage).then(() => {
        this.loading = false;
      });
    }

  },
  computed: {
    ...mapGetters({
      getVisits: 'visit/visits',
      getVisitId: 'visit/getVisitId',
      getPagination: 'visit/pagination'
    }),

    length() {
      if (this.getPagination && this.getPagination.total) {
        const perPage = this.getPagination.per_page || 10;
        return Math.ceil(this.getPagination.total / perPage);
      }
      return 0;
    },

    ...mapGetters({
      getVisitsNext: 'visitNextDay/visits',
      getVisitIdNext: 'visitNextDay/getVisitId',
      getPaginationNext: 'visitNextDay/pagination'
    }),
    visits() {
      return this.getVisits.map(visit => ({
        name: visit.user_name,
        id: visit.visit_id,
        place: visit.label,
        hour: moment(visit.visit_date).format('HH:mm'),
        status: visit.visit_status,
        label: visit.label,
        cust_code: visit.cust_code
      })) || [];
    },

    visitsNext() {
      return this.getVisitsNext.map(visit => ({
        name: visit.user_name,
        id: visit.visit_id,
        place: visit.cust_code,
        hour: moment(visit.visit_date).format('HH:mm'),
        status: visit.visit_status,
        label: visit.label
      })) || [];
    }


  },
  async mounted() {
    this.loading = true;

    await this.fetchVisits({
      date: formatUSDate(new Date())
    });

    await this.fetchVisits(() => {
      this.loading = false;
    });
    await this.fetchVisitsNext();
  }

};

</script>

<style lang="scss">

</style>

<style lang="scss">

.theme--light.v-table table {
  border: 1px solid rgba($color-ui-black, $opacity-low-min);
  thead,th, td {
     vertical-align: middle;
  }
  td:first-child {
    font-weight: bold;
    color: black;
  }
  text-align: left;
}

.theme--light.v-pagination .v-pagination__item--active {
  background: $color-ui-success;
}

.theme--light.v-pagination .v-pagination__navigation {
  background: rgba(115, 115, 115, 0.2);
}

.theme--light.v-table {
  border: 1px solid rgba($color-ui-black, $opacity-low-min);
  th, td {
     vertical-align: middle;
  }
  td:first-child {
    font-weight: bold;
    color: black;
  }
  text-align: left;
}

.theme--light.v-pagination .v-pagination__item--active {
  background: $color-ui-success;
}

.theme--light.v-pagination .v-pagination__navigation {
  background: rgba(115, 115, 115, 0.2);
}
</style>
